(function () {
  'use strict';
  if (window.PMPEDelivery && window.PMPEDelivery.version === 2) return;
  var canonical = 'Beställningsvara. Vi återkommer med preliminärt leveransdatum efter beställning.';
  var pending = Promise.resolve();
  function root() { return window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/'; }
  function config() { return window.PMPEDeliveryConfig || {}; }
  function lineText() {
    var translated = config().lineText;
    return typeof translated === 'string' && translated && !/translation.?missing|pm_pe_delivery\.line_text/i.test(translated) ? translated : canonical;
  }
  function fail() { return new Error(config().error || 'Leveransinformationen kunde inte uppdateras. Försök igen innan du går till kassan.'); }
  function props(value) {
    // Liquid serializes line-item properties as [key, value] pairs; Ajax Cart
    // returns an object. Both representations must preserve every property.
    var result = Object.create(null);
    if (value == null) return result;
    if (Array.isArray(value)) {
      value.forEach(function (entry) {
        if (!Array.isArray(entry) || entry.length !== 2 || typeof entry[0] !== 'string' || Object.prototype.hasOwnProperty.call(result, entry[0])) throw fail();
        result[entry[0]] = entry[1];
      });
    } else if (typeof value === 'object') {
      Object.keys(value).forEach(function (key) { result[key] = value[key]; });
    } else { throw fail(); }
    return result;
  }
  function signature(value) {
    var normalized = props(value);
    return JSON.stringify(Object.keys(normalized).sort().map(function (key) { return [key, String(normalized[key] == null ? '' : normalized[key])]; }));
  }
  function plan(item) { return String(item.selling_plan_id || item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id || ''); }
  function state(stock, quantity, available) {
    if (!stock || typeof stock !== 'object' || !Number.isSafeInteger(stock.eu) || stock.eu < 0 || !Number.isSafeInteger(stock.us) || stock.us < 0) return null;
    return available === true && stock.us > 0 && quantity > stock.eu;
  }
  function nextProperties(line, total) {
    var original = props(line.properties);
    var delayed = state(line.stock, total, line.available);
    if (delayed === null) return null;
    var owned = String(original._pm_pe_delivery || '') === '1';
    if (delayed) {
      if (!owned && original.Leverans) return null;
      if (owned && original.Leverans === lineText()) return null;
      original.Leverans = lineText();
      original._pm_pe_delivery = '1';
    } else {
      if (!owned) return null;
      delete original.Leverans;
      original._pm_pe_delivery = '0';
    }
    return original;
  }
  async function request(path, body) {
    var controller = new AbortController();
    var timer = window.setTimeout(function () { controller.abort(); }, 10000);
    var liquidView = /^cart\?view=pm-delivery-data(?:&|$)/.test(path);
    // Shopify ignores the alternate Liquid view when Accept requests JSON.
    // The view itself renders JSON, but must be requested as an HTML document.
    var headers = { Accept: liquidView ? 'text/html' : 'application/json' };
    if (body) headers['Content-Type'] = 'application/json';
    var response = null;
    var stage = 'network';
    try {
      response = await fetch(root() + path, {
        method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
        headers: headers,
        body: body ? JSON.stringify(body) : undefined
      });
      stage = 'parse';
      var value = await response.json();
      stage = 'response';
      if (!response.ok || value.errors) throw fail();
      return value;
    } catch (_) {
      if (window.console && typeof window.console.warn === 'function') window.console.warn('[PMPEDelivery] Request failed', {
        endpoint: liquidView ? 'cart?view=pm-delivery-data' : path.split('?')[0],
        status: response ? response.status : 0,
        contentType: response && response.headers && typeof response.headers.get === 'function' ? response.headers.get('Content-Type') : '',
        stage: stage
      });
      throw fail();
    }
    finally { window.clearTimeout(timer); }
  }
  async function reconcile(options) {
    options = options || {};
    var changed = false;
    var cart = null;
    var maximum = 2;
    for (var count = 0; count < maximum; count++) {
      var data = await request('cart?view=pm-delivery-data&_pm=' + Date.now());
      if (data.schema !== 'pm-pe-delivery-1' || !Array.isArray(data.lines) || data.lines.length !== data.line_count) throw fail();
      if (count === 0) maximum = Math.max(2, data.lines.length + 1);
      var totals = new Map();
      data.lines.forEach(function (line) {
        if (!line.key || !Number.isSafeInteger(line.quantity) || line.quantity < 1) throw fail();
        var id = String(line.variant_id);
        totals.set(id, (totals.get(id) || 0) + line.quantity);
      });
      var target = null;
      var properties = null;
      for (var i = 0; i < data.lines.length; i++) {
        var desired = nextProperties(data.lines[i], totals.get(String(data.lines[i].variant_id)));
        if (desired) { target = data.lines[i]; properties = desired; break; }
      }
      if (!target) return { cart: cart || await request('cart.js'), changed: changed };
      var body = Object.assign({ id: target.key, quantity: target.quantity, properties: properties }, options.sections || {});
      var updated = await request('cart/change.js', body);
      if (!Array.isArray(updated.items)) throw fail();
      var matches = updated.items.filter(function (item) {
        return Number(item.quantity) > 0 && String(item.variant_id || item.id) === String(target.variant_id) && plan(item) === plan(target) && signature(item.properties) === signature(properties);
      });
      if (matches.length !== 1) throw fail();
      if (typeof options.onChanged === 'function') options.onChanged(target, matches[0]);
      cart = updated;
      changed = true;
    }
    throw fail();
  }
  function reconcileCart(options) {
    var task = pending.catch(function () {}).then(function () { return reconcile(options); });
    pending = task;
    return task;
  }
  async function syncCart() {
    var manager = window.PMCartReference;
    if (manager && typeof manager.syncDelivery === 'function') return manager.syncDelivery();
    if (manager && typeof manager.flush === 'function') await manager.flush();
    var result = await reconcileCart();
    if (result.changed && window.PMCartDrawer && typeof window.PMCartDrawer.applyCart === 'function') window.PMCartDrawer.applyCart(result.cart);
    return result.cart;
  }
  window.PMPEDelivery = { version: 2, get lineText() { return lineText(); }, state: state, nextProperties: nextProperties, reconcileCart: reconcileCart, syncCart: syncCart };
  document.dispatchEvent(new CustomEvent('pm:delivery-ready'));
  if (document.getElementById('main-cart') && document.getElementById('cart')) {
    Promise.resolve().then(syncCart).catch(function (error) {
      var message = document.getElementById('cart-errors');
      if (message) message.textContent = error.message;
    });
  }
})();

